  class LoanSliderCalculator {
  constructor() {
    this.fee = 25
    this.arFee = 300;
    this.mr = 0.005;
    this.annu = false;
    this.effectiveInterestRate = 0;
    this.monthlyPayment = 0;
    this.totalCost = 0;
    this.amount = 0;
    this.repayment = 0;
  }

  calculate(amount, repayment) {
    this.amount = amount;
    this.repayment = repayment;

    let cash = this.calculateCash(repayment, amount);

    this.effectiveInterestRate = this.calculateEffectiveInterestRate(
      cash
    );
    this.totalCost = this.calculateTotalCost(cash.slice(1));
    this.monthlyPayment = this.calculateMonthlyPayment(cash.slice(1))
  }

  calculateEffectiveInterestRate(cash) {
    return (100 * (Math.pow(1 + this.irr(cash, this.mr), 12) - 1)).toFixed(2);
  }

  calculateTotalCost(cash) {
    return cash.reduce( (a,b) => a + b, 0) - this.amount + this.arFee;
  }

  calculateMonthlyPayment(cash) {
    return cash[0];
  }

  irr(cash = []) {
    let x = 1 / ( 1 + this.mr);
    let n = cash.length;

    for (let i = 0; i < 10; i++) {
      let f = cash[n - 1];
      let df = (n - 1) * cash[n - 1];

      for (let j = n - 2; j >= 1; j--) {
        f = f * x + cash[j];
        df = df * x + j * cash[j];
      }
      f = f * x + cash[0];
      let xx = x - f / df;

      if (Math.abs(x - xx) < 1e-6) {
        return 1 / xx - 1;
      }
      x = xx;
    }

    return NaN;
  }

  calculateCash(repayment, balance) {
    let balanceR = balance;

    let resp = [-balance + this.arFee];

    for (let i = 1; i <= repayment; i++) {
      let item = 0;
      let ammort = 0;
      let interest = Math.round(balanceR * this.mr);
      if (this.annu) {
        let r = 1 / (1 + this.mr)
        item = Math.round(balanceR / ((1 - Math.pow(r, repayment + 2 - i)) / (1 - r) - 1));
        ammort = item - interest;
      } else {
        ammort = Math.round(balanceR / (repayment + 1 - i))
        item = ammort + interest;
      }

      balanceR -= ammort;
      resp.push(item + this.fee);
    }

    return resp;
  }
}

export default LoanSliderCalculator;



// WEBPACK FOOTER //
// ./scripts/libs/LoanSliderCalculator.js